import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const composeBorder = `1px solid ${grey[300]}`;

const useStyles = makeStyles(({ spacing, palette }) => ({
  grid: {
    overflow: "auto",
    maxHeight: "395px",
  },
  hiddingBox: {
    top: 0,
    left: 0,
    position: "sticky",
    zIndex: 1,
    background: palette.attachmentsBackground.main,
    width: "100%",
    minWidth: "220px",
    maxWidth: "290px",
  },
  viewOnlyHiddingBox: {
    minWidth: "200px",
    maxWidth: "270px",
  },
  uponLeftCell: {
    height: "12px",
    width: "100%",
    minWidth: "220px",
    maxWidth: "290px",
    borderRight: `1px solid ${palette.separator.main}`,
    background: palette.attachmentsBackground.main,
  },
  marginBox: {
    width: "20px",
    minWidth: "20px",
    height: "100%",
    background: palette.attachmentsBackground.main,
  },
  headCell: {
    width: "100%",
    minWidth: "200px",
    maxWidth: "270px",
    borderRadius: "8px 0px 0px 0px",
    borderLeft: `1px solid ${palette.separator.main}`,
    borderBottom: `1px solid ${palette.separator.main}`,
    background: palette.attachmentsBackground.main,
    borderTop: `1px solid ${palette.separator.main}`,
    padding: spacing(0, 1.5),
    alignItems: "center",
    height: "calc(100% - 12px)",
    maxHeight: "48px",
    position: "relative",
  },
  smallRowTitle: {
    width: "48px",
    minWidth: "48px",
    maxWidth: "48px",
    minHeight: "48px",
    maxHeight: "100%",
    background: grey[50],
    borderRadius: "8px 0px 0px 0px",
    border: `1px solid ${palette.separator.main}`,
  },
}));

export default useStyles;
